module.exports = __webpack_public_path__ + "img/capitalboxflex@2x.793162c.png";